import { Toaster as SonnerToaster } from 'sonner'

type ToasterProps = React.ComponentProps<typeof SonnerToaster>

export function Toaster(props: ToasterProps) {
  return (
    <SonnerToaster
      richColors
      closeButton
      position="top-center"
      toastOptions={{
        style: {
          backgroundColor: 'hsl(var(--popover))',
          color: 'hsl(var(--popover-foreground))',
          borderRadius: '18px',
          border: '1px solid hsl(var(--border) / 0.45)',
          boxShadow: '0 22px 70px -32px rgba(15, 23, 42, 0.6)',
          backdropFilter: 'blur(18px)',
        },
      }}
      {...props}
    />
  )
}
